/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import Tippy from '@tippyjs/react';
import { TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { ALL_MODULES, Loader, useIsAuthorisedHook } from '@nile/components';
import WorklogManualTimer from '@nile/components/src/Containers/NewWorklog/WorklogManualTimer';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import styled from 'styled-components';
import TimeFormatCell from './TimeFormatCell';
import { FormattedMessage } from 'react-intl';

const WorklogTimerCellContainer = styled.div`
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

const WorklogEditPopupContainer = styled.div`
  min-width: 500px;
  .notes-editor .Superops-TextField__Input {
    min-height: 100px;
    max-height: calc(100vh - 330px);
  }
  .modal-loading {
    opacity: 0.6;
    z-index: 10;
  }
`;

const WorklogCell = (props) => {
  const { cell } = props;
  const { actions } = cell.column;
  const { editable } = cell.column;
  const worklog = cell?.row?.original;
  const { status } = cell?.row?.original;
  const approved = status !== 'PENDING';
  const isTicket = worklog?.workItem?.module === ALL_MODULES.ticket;
  const isEditAuthorised = isTicket
    ? useIsAuthorisedHook('tickets.edit')
    : true;
  const isEditable = editable && !approved && isEditAuthorised;

  return cell?.value ? (
    <WorklogTimerCellContainer
      className={`${isEditable ? 'editable-cell' : ''} flex center fw p10`}
    >
      {approved && (
        <span className="fx actr mr-10">
          <SVGIcon name="InvoiceLogo" />
        </span>
      )}
      <TimeFormatCell {...props} />
      {isEditable && (
        <div className="edit-actions">
          <EditWorklog
            log={worklog}
            module={worklog?.module}
            workItem={worklog?.workItem}
            deleteWorklog={actions?.deleteWorklogEntry}
          />
        </div>
      )}
    </WorklogTimerCellContainer>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
};

const EditWorklog = (props) => {
  const { log, workItem, module, deleteWorklog } = props;
  const tippyRef = React.useRef(null);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(false);
  const popupParentName = 'WorklogEntryPopup';

  const closeAllOpenPopups = () => {
    if (
      document.getElementsByClassName(popupParentName) &&
      document.getElementsByClassName(popupParentName)?.length
    ) {
      Array.prototype.forEach.call(
        document.getElementsByClassName(popupParentName),
        (popup) => {
          if (popup?._tippy?.state?.isVisible) {
            popup?._tippy.hide();
          }
        }
      );
    }
  };

  function handleClickOutside(e) {
    if (
      !tippyRef.current?._tippy?.popper.contains(e.target) &&
      tippyRef.current?._tippy?.state?.isVisible
    ) {
      closePopup();
    }
  }

  function closePopup() {
    setMounted(false);
    tippyRef.current._tippy.hide();
    // document.removeEventListener('click', handleClickOutside);
  }

  const togglePopover = () => {
    if (tippyRef?.current?._tippy) {
      if (!tippyRef.current?._tippy?.state?.isVisible) {
        setMounted(true);
        closeAllOpenPopups();
        tippyRef.current._tippy.show();
        setTimeout(() => {
          tippyRef.current._tippy.popperInstance.forceUpdate();
        }, 1000);
        // document.addEventListener('click', handleClickOutside);
      } else {
        closePopup();
      }
    }
  };

  function repositionPopup() {
    if (tippyRef.current._tippy) {
      tippyRef.current._tippy.popperInstance.forceUpdate();
    }
  }

  return (
    <Tippy
      content={
        mounted ? (
          <WorklogEditPopupContainer
            onChange={repositionPopup}
            className="position-relative"
          >
            {loading && (
              <div className="modal-loading fx actr jctr fw fhp white-bg position-absolute">
                <Loader />
              </div>
            )}
            <div className="fx actr mb10 p20 pb-5 pt10">
              <TextStyle weight="Bold">
                <FormattedMessage id="workItem.details.worklog.edit" />
              </TextStyle>
            </div>
            <WorklogManualTimer
              timer={log}
              handleClose={closePopup}
              module={module}
              workItem={workItem}
              workLogEdit
              taskViewOnly
            />
          </WorklogEditPopupContainer>
        ) : null
      }
      trigger="manual" // manually close the tip on api calls
      interactive
      placement="left"
      arrow={false}
      theme="light"
      allowHTML
      ref={(node) => {
        tippyRef.current = node;
      }}
      appendTo={document.body}
      offset={[30, 30]}
      hideOnClick="toggle"
      maxWidth={500}
      zIndex={510}
    >
      <div
        key={log?.itemId}
        className={`mlauto ptr position-relative ${popupParentName}`}
        onClick={togglePopover}
      >
        <SVGIcon name="Edit" />
      </div>
    </Tippy>
  );
};

export default WorklogCell;
